/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_FailedInputs */

const en_us2_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The import stopped. What was sent stays; trying again sends only the rest.`)
};

const pt_br2_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A importação parou. O que foi enviado fica; tentar de novo envia só o resto.`)
};

const es_419_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La importación se detuvo. Lo enviado se conserva; si lo intentas de nuevo, solo se envía el resto.`)
};

const pt_pt2_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A importação parou. O que foi enviado fica; tentar outra vez envia só o resto.`)
};

const fr_fr2_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'import s'est arrêté. Ce qui a été envoyé est conservé ; réessayer n'envoie que le reste.`)
};

const de_de2_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Import wurde unterbrochen. Was schon gesendet wurde, bleibt; ein neuer Versuch sendet nur den Rest.`)
};

const it_it2_history_transfer_failed = /** @type {(inputs: History_Transfer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'importazione si è fermata. Quello che è stato inviato resta; riprovando si invia solo il resto.`)
};

/**
* | output |
* | --- |
* | "The import stopped. What was sent stays; trying again sends only the rest." |
*
* @param {History_Transfer_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_failed = /** @type {((inputs?: History_Transfer_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_failed(inputs)
	if (locale === "es-419") return es_419_history_transfer_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_failed(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_failed(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_failed(inputs)
	return en_us2_history_transfer_failed(inputs)
});
export { history_transfer_failed as "history-transfer.failed" }